import React, { useState, useCallback, useContext } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {
    Modal,
    Button,
    Alert,
    Spinner
} from "react-bootstrap";

import AuthenticatedUserContext from "../../context/AuthenticatedUserContext";
import ProfileAddressForm from "./ProfileAddressForm";

function ProfileAddressEditModal({ show, handleClose }) {
    const { user, refreshSessionFunction } = useContext(AuthenticatedUserContext);
    
    const [formData, setFormData] = useState({
        address: user.address,
        postalCode: user.postalCode,
        city: user.city,
        country: user.country
    });
    
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [saving, setSaving] = useState(false);

    const handleSave = useCallback(() => {
        setError(null);
        setSuccess(false);
        setSaving(true);

        if (!formData.address || !formData.postalCode || !formData.city || !formData.country) {
            setError("Vul alle velden in.");
            setSaving(false);
            return;
        }

        axios.post("/setUserAddress", formData)
            .then((response) => {
                if (response.data.valid) {
                    setSuccess(true);
                    
                    refreshSessionFunction();
                    
                    setTimeout(() => {
                        handleClose();
                        setSuccess(false);
                    }, 1500);
                } else {
                    setError("Er was een fout bij het opslaan van de adresgegevens. (" + response.data.error + ")");
                }
            })
            .catch((requestError) => {
                console.error(requestError);
                setError("Er was een fout bij het opslaan van de adresgegevens.");
            })
            .finally(() => {
                setSaving(false);
            });
    }, [formData, refreshSessionFunction, handleClose]);

    return (
        <Modal show={show} onHide={handleClose} className="modal-dark">
            <Modal.Header closeButton>
                <Modal.Title>Adresgegevens wijzigen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {success && (
                    <Alert variant="success">Adresgegevens zijn opgeslagen.</Alert>
                )}
                {error && (
                    <Alert variant="danger">{error}</Alert>
                )}
                
                <ProfileAddressForm 
                    formData={formData}
                    setFormData={setFormData}
                    saving={saving}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={saving}>
                    Annuleren
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={saving}>
                    {saving && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2" />
                    )}
                    Opslaan
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ProfileAddressEditModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

export default React.memo(ProfileAddressEditModal);
